<template>
  <div class="tree-box nochoose"  style="position: relative;">
    <div class="tree-content" @click="click_task = {}">
      <!-- 一级 start -->
      <div v-for="(item, index) in localTreeData" :key="item.id + 'levle1'">
        <div class="level1-item-box item-focus"
             @click="onclickLevel1Item(item, index)"
             @dragover="dragoverLevel1($event)"
             @dragleave="dragleaveLevel1($event)"
             @drop="dropLevel1($event, index)"
             v-if="item.show_tree === true"
        >
          <div class="left-arr-box">
            <img src="@/assets/icon_down_white.png" v-show="item.isExpand">
            <img src="@/assets/icon_right_white.png" v-show="!item.isExpand">
          </div>
          <div class="set-box">
            <img src="../../../../assets/diapatch/setting.png" alt="">
          </div>
          <div class="content-box">
            <div class="title">{{ item.name }}</div>
            <div class="subtitle">{{ item.duty }} {{ item.title }}</div>
          </div>
        </div>
        <div v-if="item.isExpand">
          <!-- 临时派单任务节点 -->
          <div v-if="item.task_list">
            <div v-if="item.task_list.length > 0">
              <div v-for="(itemtemp, indexTemp) in item.task_list" :key="itemtemp.task_id">
                <div class="level3-item-box item-focus" style="padding-left: 24px;" :draggable="draggable"
                     @dragstart="dragstartTempTask($event,itemtemp, index, indexTemp)"
                     @contextmenu.prevent="rightClicks($event,itemtemp)"
                     @click="findeTaskInMap(itemtemp)"
                     @drag="drag($event)"
                >
                  <div v-if="itemtemp.type == 'dropoff' || itemtemp.type == 'pickup'" class="item-row">
                    <div class="task-index">{{ indexTemp + 1 }}</div>
                    <div class="task-icon">
                      <img :src="changetaskImg(itemtemp)" alt="">
                    </div>
                    <div class="content-box" style="margin-left: 4px;">
                      <div class="title" style="font-size: 12px;" v-if="itemtemp.abs">{{ itemtemp.address }}{{',&nbsp;'+itemtemp.abs}}</div>
                      <div class="title" style="font-size: 12px;" v-else>{{ itemtemp.address }}</div>

                      <div class="subtitle">
                        <img v-if="itemtemp.set_urgency == 1" class="task-icon-urgency" src="../../../../assets/diapatch/rush.png">
                        {{ itemtemp.invoice_number }}/{{ itemtemp.suffix }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
          <!-- 二级 start-->
          <div v-for="(item2, index2) in item.childen_data" :key="item2.worker_id">
            <div class="level2-item-box item-focus"
                 @dragover="dragoverLevel2($event)"
                 @dragleave="dragleaveLevel2($event)"

                 @contextmenu.prevent="rightClicksDriver($event,item2)"
                 @drop="dropLevel2($event, index, index2)"
                 :class="current_store_id== item.id && currentDriverId == item2.id && currentDriverItemFoucs ? 'active-driver' : ''"
            >
              <div class="item-row">
                <div v-if="current_store_id== item.id &&currentDriverId == item2.id && currentDriverItemFoucs">
                  <div class="left-arr-box"  @click="onclickLevel2Item(item2, index2, index)">
                    <img src="@/assets/diapatch/icon_down.png" v-show="item2.isExpand">
                    <img src="@/assets/diapatch/icon_right.png" v-show="!item2.isExpand">
                  </div>
                </div>
                <div v-else>
                  <div class="left-arr-box"  @click="onclickLevel2Item(item2, index2, index)">
                    <img src="@/assets/icon_down_white.png" v-show="item2.isExpand">
                    <img src="@/assets/icon_right_white.png" v-show="!item2.isExpand">
                  </div>
                </div>
                <div class="set-box"  @click="findeDriverInMap(item,item2)">
                  <img v-if="item2.is_transfer == 0 && item2.is_online == 1" src="../../../../assets/diapatch/free.png" alt="">
                  <img v-if="item2.is_transfer == 1 && item2.is_online == 1" src="../../../../assets/diapatch/transit.png" alt="">
                  <img v-if="item2.is_online == 0" src="../../../../assets/diapatch/notOnline.png" alt="">
                </div>
                <div class="content-box" @click="drawTaskLine(item,index,index2,item2)">
                  <div class="title">{{ item2.name }}</div>
                  <div class="subtitle">
                    <span v-text="item2.is_online == 0 ? 'Offine' : item2.is_transfer == 0 ? 'idle' : 'In transit'"></span>
                    {{ item2.title_count }} Of {{ item2.title_total_count }}
                  </div>
                </div>
              </div>

            </div>
            <div v-if="item2.isExpand" :class="current_store_id== item.id &&currentDriverId == item2.id && currentDriverItemFoucs ? 'active-task' : 'active-task-def'">
              <!-- 三级 start-->
              <div v-for="(item3, index3) in item2.childen_data" :key="item3.task_id" style="display:flex;flex-direction:row;align-items:center">

                <div class="task-icon" style="margin-right:0px;padding-left:8px" v-if="item3.delayStatus == 1">
                      <img src="../../../../assets/diapatch/upcoming_late@2x.png" alt="">
                </div>

                <div class="level3-item-box item-focus" :style="item3.delayStatus==1 ? 'margin-left:2px':''"
                     :draggable="draggable"
                     @dragstart="dragstart($event,item3, index, index2, index3)"
                     @dragenter="dragenter($event, index, index2, index3)"
                     @dragover="dragoverLevel3($event)"
                     @drop="dropLevel3($event, index, index2, index3)"
                     @dragleave="dragleaveLevel3($event)"
                     @contextmenu.prevent="rightClicks($event,item3)"
                     v-if="item3.status !=3 && item2.status!=4"
                     @click="findeTaskInMap(item3)">
                  <div
                    :class="{active_task: click_task?.task_id == item3.task_id}"
                    v-if="item3.type == 'dropoff' || item3.type == 'pickup'" class="item-row">
                    <div class="task-index">{{ index3 + 1 }}</div>
                    <div class="task-icon">
                      <img :src="changetaskImg(item3,2)" alt="">
                    </div>

                    <div class="content-box" style="margin-left: 4px;">
                      <div class="title" style="font-size: 12px;" v-if="item3.abs">{{ item3.address }} {{',&nbsp;'+item3.abs}}</div>
                      <div class="title" style="font-size: 12px;" v-else>{{ item3.address }}</div>

                      <div class="subtitle">
                        <img v-if="item3.set_urgency == 1" class="task-icon-urgency" src="../../../../assets/diapatch/rush.png">
                        {{ item3.invoice_number }}/{{ item3.suffix }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 三级end -->
            </div>
          </div>
          <!-- 二级end -->
        </div>
      </div>
      <!-- 一级end -->
    </div>
    <!--    选中后多选的dom 试运行-->
<!--    <div v-if="assignedDraggedItems.length"-->
<!--         class="dragging-layer"-->
<!--         :style="`top: ${assignedTempY}px; left: ${assignedTempX}px;`">-->
<!--      <div v-for="(item, index) in assignedDraggedItems"-->
<!--           :key="item.task_id + index"-->
<!--           class="drag-item active_task">-->
<!--        <div v-if="item.type == 'dropoff' || item.type == 'pickup'" class="item-row">-->
<!--          <div class="task-index">{{ index + 1 }}</div>-->
<!--          <div class="task-icon">-->
<!--            <img :src="changetaskImg(item)" alt="">-->
<!--          </div>-->
<!--          <div class="content-box" style="margin-left: 4px;">-->
<!--            <div class="title" style="font-size: 12px;" v-if="item.abs">{{ item.address }}{{',&nbsp;'+item.abs}}</div>-->
<!--            <div class="title" style="font-size: 12px;" v-else>{{ item.address }}</div>-->

<!--            <div class="subtitle">-->
<!--              <img v-if="item.set_urgency == 1" class="task-icon-urgency" src="../../../../assets/diapatch/rush.png">-->
<!--              {{ item.invoice_number }}/{{ item.suffix }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>

import icon_unassignO from "@/assets/diapatch/task/unassignO.png";
import icon_purpleO from "@/assets/diapatch/task/pin(5).svg";
import icon_buleO from "@/assets/diapatch/task/bule.png"
import icon_greenO from "@/assets/diapatch/nomal/icon_greenO.png"
import icon_redO from "@/assets/diapatch/nomal/icon_redO.png"
import icon_buleP from "@/assets/diapatch/task/pin(2).svg";
import icon_greenP from "@/assets/diapatch/task/pin(4).svg";
import icon_redP from "@/assets/diapatch/task/pin(3).svg";
import icon_unassignP from "@/assets/diapatch/task/unassignP.png";
import icon_purpleP from "@/assets/diapatch/task/pin(1).svg";
import {assignTasks, sortTaskList} from "@/api/dispatch";
import store from "@/store/index";
//右键点击
export default {
  name: 'me-tree',
  props: {
    //是否全部展开
    isExpand: {
      type: Boolean,
      default: () => true
    },
    //新来的任务数据
    newTask: {
      type: Array,
      default: () => []
    },
    //拖拽走的任务数据
    dropLeaveTreeTask: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      assignedTempY:0,
      assignedTempX:0,
      chaOnce:9999,
      ctrlKeyActive:false,//监听当前ctrl键是否按下
      assignedDraggedItems:[],
      draggable: true,

      dragIndex: '',
      enterIndex: '',
      timeout: null,
      driverIndex: '',
      storeIndex: '',
      newdropTask: {},
      tempStoreIndex: '',
      tempDragIndex: '',
      click_task:{},
      currentDriverId: '',
      currentDriverItemFoucs: false,
      current_store_id:'',
    }
  },
  computed: {
    localTreeData(){
      // 将成功/失败的任务置底 这样index 就不会有问题 但是需要在每次完成任务之后 都将成功/失败的任务置地
      let arr = store.state.dis_team_list
      arr.forEach(store=>{
        store.childen_data.forEach(driver=>{
          driver.childen_data.forEach((task,index)=>{
            task.x = 0
            task.y = 0
            if (task.status == 3 || task.status == 4){
              // if (index === driver.childen_data.length - 1) return false
              // 删除当前数组元素，并将被删除的值添加到数组末尾
              // driver.childen_data.push(driver.childen_data.splice(index, 1)[0])
              // console.log('--完成或失败的任务删除----')//2023年8月25日
              driver.childen_data.splice(index, 1)
            }
          })
        })
      })

      return arr
    },

  },
  methods: {
    reloadTreeStatus(){
      let expandList = JSON.parse(sessionStorage.getItem('expandList'))
      if  (expandList){
        // console.log(this.localTreeData,'expandListexpandListexpandListexpandList')
        this.localTreeData.forEach((v,index)=>{
          let openItem = expandList.findIndex(b=>b.id == v.id)
          if  (openItem>-1){
            this.localTreeData[index].isExpand = true
            this.localTreeData[index].childen_data.forEach((z,zIndex)=>{
              let child_id = expandList[openItem].child.findIndex(c=>c.id == z.id)
              if (child_id>-1){
                this.localTreeData[index].childen_data[zIndex].isExpand = true
              }
            })
          }
        })
      }
    },
    findeDriverInMap(item,data){
      data.show_map_driver = true
      this.$emit('openDriverInfo',data)
    },
    findeTaskInMap(data){
      // console.log(data,'dadadadfadsfasdfafdfafsdf')
      this.$emit('findMarker',data.task_id,data)
    },
    rightClicks(event, task) {
      this.$emit('rightClicks',event,task)
    },
    rightClicksDriver(event,driver){
      this.$emit('rightCliksDriver',event,driver)
    },
    dragstartTempTask(event,item, index, indexTemp) {
      // 隐藏原始拖动元素
      // event.dataTransfer.setDragImage(new Image(), 0, 0);
      // console.log('--临时任务start---->', item, index, indexTemp)
      this.tempStoreIndex = index
      this.tempDragIndex = indexTemp
      this.$emit('dropStartMeTree', item)//通知父组件当前司机组别中任务已经被拖拽
      // this.assignedDraggedItems = this.localTreeData[index].task_list
    },
    drag(event,index){
      // event.preventDefault();
      let minLeft = window.outerWidth -(640-16)
      let clientX = event.clientX
      let cha = 0
      if(clientX>minLeft){
        if(this.chaOnce == 9999){
          cha = clientX-minLeft
          this.chaOnce = cha
        }
      }
      this.assignedTempX = event.clientX-(window.outerWidth-640+this.chaOnce) //- 1300
      this.assignedTempY = event.clientY - 100
    },
    //地图点击 打开父节点并高亮 choose_task
    chooseTreeData(index,a){
      let driver = a.parent_driver
      let parent_store_arr = []
      if (typeof (a.parent_store) == 'string'){
        if(a.parent_store !=undefined){
          let parentSoreArr=a.parent_store.split('#')
          parentSoreArr.forEach((p)=>{
            if(p!='undefined' && p!=''){
              parent_store_arr.push(parseInt(p))
            }
          })
        }
      }else{
        parent_store_arr = a.parent_store
      }

      // let store_index = this.localTreeData.findIndex(v=>v.id == store)
      let arr = store.state.dis_team_list
      arr.forEach((store,index)=>{
        let store_flage = parent_store_arr.findIndex(v=>v == store.id)
        if (store_flage>-1){
          let driver_index = arr[index].childen_data.findIndex(b=>b.worker_id == driver)
          let task_index =arr[index].childen_data[driver_index].childen_data.findIndex(c=>c.task_id == a.task_id)
          arr[index].isExpand = true
          arr[index].childen_data[driver_index].isExpand = true
          this.click_task = arr[index].childen_data[driver_index].childen_data[task_index]
          this.$forceUpdate()
        }
      })
    },
    //底部设置
    settingHandle(e){
      this.localTreeData.forEach(item=>{
        e.forEach(b=>{
          if (item.id == b){
            item.show_tree = true
          }else {
            item.show_tree = false
          }
        })
      })
      this.$forceUpdate()
    },
    //拖拽释放 店铺层级
    dropLevel1(e, index) {
      this.assignedTempY = 0
      this.assignedTempX = 0
      if (this.newdropTask[0] !== undefined && this.newdropTask[0].id != null) {
        this.assignedAllTask(this.newdropTask,index)
        this.newdropTask = {}
      } else {
        if (this.storeIndex !== '') {
          if (this.driverIndex !== '') {
            // 从司机到临时店铺
            const source = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data[this.dragIndex]
            this.assignedAllTask([source],index)
          }
          //判断开始拖拽的司机分组是否还有数据
          let length = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data.length
          if (length == 0) {
            let itemObj = Object.assign(this.localTreeData[this.storeIndex].childen_data[this.driverIndex], { isExpand: false })
            this.$set(this.localTreeData[this.storeIndex].childen_data, this.driverIndex, itemObj)
          }
        }else{
          if(index == this.tempStoreIndex){
          }else{
            const source = this.localTreeData[this.tempStoreIndex].task_list[this.tempDragIndex]
            this.assignedAllTask([source],index)
          }
        }
      }
      // let itemObj = Object.assign(this.localTreeData[index], { isExpand: true })
      // this.$set(this.localTreeData[index], index, itemObj)
      // this.localTreeData = [...this.localTreeData]//刷新列表数据dom更新
      e.currentTarget.style.border = 'none'
      this.resetval()
      this.$emit('dropMeTreeCompleted') //通知父组件树的拖拽操作已经完成（释放）
    },
    //当前任务已经被拖到其他组件并释放（newtask）
    delDropTreeTask() {
      //,那么删除被拖拽走的任务
      // this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data.splice(this.dragIndex, 1)
      //判断开始拖拽的司机分组是否还有数据
      if (this.storeIndex !== '') {
        let length = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data.length
        if (length == 0) {
          let itemObj = Object.assign(this.localTreeData[this.storeIndex].childen_data[this.driverIndex], { isExpand: false })
          this.$set(this.localTreeData[this.storeIndex].childen_data, this.driverIndex, itemObj)
        }
      }
    },
    //拖拽释放 司机层级
    dropLevel2(e, index, index2) {
      //从unassigned 过来的d tempStoreIndex
      if (this.newdropTask[0] !== undefined && this.newdropTask[0].id != null) {
        let arr = JSON.parse(JSON.stringify(this.localTreeData[index].childen_data[index2].childen_data))
        let driver = this.localTreeData[index].childen_data[index2]
        var arr2 = [...arr,...this.newdropTask]
        this.sortList(arr2,driver)
        this.assignedAllTask(this.newdropTask,index,index2)
        this.newdropTask = {}
        //展开当前司机组别节点
        let isExpand = this.localTreeData[index].childen_data[index2].isExpand
        if (!isExpand) {
          let itemObj = Object.assign(this.localTreeData[index].childen_data[index2], { isExpand: true })
          this.$set(this.localTreeData[index].childen_data, index2, itemObj)
        }
      } else {
        if (this.storeIndex === index && this.driverIndex === index2) {
          // console.log('相同店铺相同司机组不需要操作')
        } else {
          //不同店铺之间
          if (this.storeIndex !== '') {
            if (this.driverIndex !== '') {
              if (this.dragIndex !== '') {
                //1.移除原来司机组别的任务item
                //2.添加到新的司机组的列表
                const source = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data[this.dragIndex]
                let arr = JSON.parse(JSON.stringify(this.localTreeData[index].childen_data[index2].childen_data))
                let driver = this.localTreeData[index].childen_data[index2]
                arr.push(source)
                this.sortList(arr,driver)
                this.assignedAllTask([source],index,index2)
                //需要将当前司机节点展开
                let isExpand = this.localTreeData[index].childen_data[index2].isExpand
                if (!isExpand) {
                  let itemObj = Object.assign(this.localTreeData[index].childen_data[index2], { isExpand: true })
                  this.$set(this.localTreeData[index].childen_data, index2, itemObj)
                }
              }
            }
          } else {
            const source = this.localTreeData[this.tempStoreIndex].task_list[this.tempDragIndex]
            // this.localTreeData[this.tempStoreIndex].task_list.splice(this.tempDragIndex, 1)
           let test_arr = JSON.parse(JSON.stringify(this.localTreeData[index].childen_data[index2].childen_data))
            test_arr.push(source)
            const newArray = test_arr.slice()
            let arr3 = newArray.filter(item=>item.status== 1 || item.status == 2)
            let worker_id = this.localTreeData[index].childen_data[index2]
            this.sortList(arr3,worker_id)
            this.assignedAllTask([source],index,index2)
            //需要将当前司机节点展开
            let isExpand = this.localTreeData[index].childen_data[index2].isExpand
            if (!isExpand) {
              let itemObj = Object.assign(this.localTreeData[index].childen_data[index2], { isExpand: true })
              this.$set(this.localTreeData[index].childen_data, index2, itemObj)
            }
            // this.localTreeData = [...this.localTreeData]//刷新列表数据dom更新
          }
        }
      }

      //判断开始拖拽的司机分组是否还有数据
      if (this.storeIndex !== '') {
        let length = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data.length
        if (length == 0) {
          let itemObj = Object.assign(this.localTreeData[this.storeIndex].childen_data[this.driverIndex], { isExpand: false })
          this.$set(this.localTreeData[this.storeIndex].childen_data, this.driverIndex, itemObj)
        }
      }
      e.currentTarget.style.border = 'none'
      this.resetval()
      this.$emit('dropMeTreeCompleted') //通知父组件树的拖拽操作已经完成（释放）

    },
    //拖拽释放 任务层级
    dropLevel3(e, index, index2, index3) {
      //从unassigned 过来的
      if (this.newdropTask[0] !== undefined && this.newdropTask[0].id != null) {
        this.assignedAllTask(this.newdropTask,index,index2)
        let arr = JSON.parse(JSON.stringify(this.localTreeData[index].childen_data[index2].childen_data))
        let driver = this.localTreeData[index].childen_data[index2]
        let arr2  = this.newdropTask
        arr2.unshift(index3,0)
        Array.prototype.splice.apply(arr, arr2);
        this.sortList(arr,driver)
        this.newdropTask = {}
      } else {
        // 司机之间拖拽 或者任务排序
        if (this.storeIndex !== '') {
          const source = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data[this.dragIndex]
          if (index != undefined && index == this.storeIndex) {
            if (index2 != undefined && index2 == this.driverIndex) {
              if (index3 != undefined && index3 != this.dragIndex) {
                //排序
                let obj = JSON.parse(JSON.stringify(this.localTreeData))
                obj[index].childen_data[index2].childen_data.splice(this.dragIndex, 1)
                obj[index].childen_data[index2].childen_data.splice(index3, 0, source)
                this.sortList(obj[index].childen_data[index2].childen_data,obj[index].childen_data[index2])
                this.dragIndex = index3;
              } else {
              }
            } else {
              this.assignedAllTask([source],index,index2)
              //将排序后传给后端
              let arr = JSON.parse(JSON.stringify(this.localTreeData[index].childen_data[index2].childen_data))
              let driver = this.localTreeData[index].childen_data[index2]
              arr.splice(index3, 0, source)
              this.sortList(arr,driver)
            }
          } else {
          }
        } else {
          //临时店铺
          const source = this.localTreeData[this.tempStoreIndex].task_list[this.tempDragIndex]
          this.localTreeData[this.tempStoreIndex].task_list.splice(this.tempDragIndex, 1)
          this.assignedAllTask([source],index,index2)
          let arr = JSON.parse(JSON.stringify(this.localTreeData[index].childen_data[index2].childen_data))
          let driver = this.localTreeData[index].childen_data[index2]
          arr.splice(index3, 0, source)
          this.sortList(arr,driver)
        }
      }

      //判断开始拖拽的司机分组是否还有数据
      if (this.storeIndex !== '') {
        let length = this.localTreeData[this.storeIndex].childen_data[this.driverIndex].childen_data.length
        if (length == 0) {
          let itemObj = Object.assign(this.localTreeData[this.storeIndex].childen_data[this.driverIndex], { isExpand: false })
          this.$set(this.localTreeData[this.storeIndex].childen_data, this.driverIndex, itemObj)
        }
      }

      e.currentTarget.style.border = 'none'
      this.resetval()
      this.$emit('dropMeTreeCompleted') //通知父组件树的拖拽操作已经完成（释放）
    },

    //调分配接口
    assignedAllTask(task,index,index2){
      let arr = []
      task.forEach(v=>{arr.push(v.task_id)})
      let worker_id = ""
      if  (index2 == 0 || index2 > 0){
        worker_id = this.localTreeData[index].childen_data[index2].worker_id
      }
      let team_id =this.localTreeData[index].id
      assignTasks({
        tasks:arr,
        worker_id:worker_id,
        team_id:team_id,
      }).then(res=>{
        if (res.code == 200){

        }else{
          this.$message({
            type:"error",
            message:res.msg
          })
        }
      })
    },

    //点击司机节点 让地图上的任务跟司机连线
    drawTaskLine(item,index,index2,item2){
      if (this.currentDriverId == item2.id && this.current_store_id == item.id) {
        this.currentDriverItemFoucs = !this.currentDriverItemFoucs
      } else {
        this.currentDriverItemFoucs = true
      }
      this.currentDriverId = item2.id
      this.current_store_id = item.id
      let line_arr = []
      store.state.task_draw_line_arr = []
      //这里 需要去state中取出地图上的点
     store.state.dis_map_point_data.map_driver_list?.forEach(v=>{
        // if (v.show_map){
          if (item2.worker_id == v.worker_id){
            item2.latitude =Number(v.position.lat)
            item2.longitude =Number(v.position.lng)
            // console.log('地图上找到了',v.show_map,v.position.lat,v.position.lng, v )
          }
        // }
      })
      // console.log(item2.is_online)
      if (item2.is_online == 1){
        line_arr.unshift({
          type:'driver',
          latitude:item2.latitude,
          longitude:item2.longitude,
          name:item2.name,
          worker_id:item2.worker_id,
        })
      }
      item2.childen_data.forEach(v=>{
        if (v.status == 1 || v.status == 2){
          line_arr.push(v)
        }
      })
      // console.log(line_arr,'看看司机连线')
      store.commit('changeTaskLineArr',line_arr)
    },
    // 在调用排序接口时，需要一个数组临时存放插入的数组位置然后传给后端
    sortList(data,driver){
      let sortList = []
      data.forEach(sort=>{
        if  (sort.status ==0|| sort.status == 1 || sort.status == 2){
          sortList.push([sort.task_id])
        }
      })
      sortTaskList({
        worker_id:driver.worker_id,
        id:driver.id,
        task_sort:sortList,
      }).then(res=>{
      })
    },


    dragoverLevel3(e) {
      e.preventDefault();
      // e.currentTarget.style.borderTop = '1px solid #FFFFFF'
      e.currentTarget.style.border = '1px dashed #FFFFFF'
    },
    dragleaveLevel3(e) {
      e.preventDefault();
      e.currentTarget.style.border = 'none'
    },
    dragoverLevel2(e) {
      e.preventDefault();
      e.currentTarget.style.border = '1px solid #FFFFFF'
    },
    dragleaveLevel2(e) {
      e.preventDefault();
      e.currentTarget.style.border = 'none'
    },
    dragoverLevel1(e) {
      e.preventDefault();
      e.currentTarget.style.border = '1px solid #FFFFFF'
    },
    dragleaveLevel1(e) {
      e.preventDefault();
      e.currentTarget.style.border = 'none'
    },

    //开始拖拽
    dragstart(event,item, index, index2, index3) {
      // 隐藏原始拖动元素
      // event.dataTransfer.setDragImage(new Image(), 0, 0);
      // this.assignedDraggedItems = this.localTreeData[index].childen_data[index2].childen_data
      // console.log(this.assignedDraggedItems,'ddddddd')

      if (index3 ==0 || index3 >0){
        this.dragIndex = index3
      }
      this.driverIndex = index2
      this.storeIndex = index
      this.$emit('dropStartMeTree', item)//通知父组件当前司机组别中任务已经被拖拽
    },
    dragenter(){

    },
    resetval() {
      this.dragIndex = ''
      this.enterIndex = ''
      this.driverIndex = ''
      this.storeIndex = ''
    },
    onclickLevel1Item(item, index) {
      let isExpand = !item.isExpand
      // console.log('---点击了--', item, isExpand,item.isExpand,index)
      item = Object.assign(item, { isExpand })
      this.$set(this.localTreeData, index, item)
      //将点击后的一级 id存储再session 刷新后去session 中取
      if (isExpand){
        let expandList =JSON.parse(sessionStorage.getItem('expandList'))
        if (expandList){
          let findId = expandList.findIndex(v=>v.id == item.id)
          if (findId == -1){
            expandList.push({id:item.id,child:[]})
            sessionStorage.setItem('expandList',JSON.stringify(expandList))
          }
        }else {
          let arr = []
          arr.push({id:item.id,child:[]})
          sessionStorage.setItem('expandList',JSON.stringify(arr))
        }
      }else {
        let expandList =  JSON.parse(sessionStorage.getItem('expandList'))
        let clearnId = expandList.findIndex(v=> v.id == item.id)
        if (clearnId >-1){
          expandList.splice(clearnId,1)
          sessionStorage.setItem('expandList',JSON.stringify(expandList))
        }
      }
    },
    onclickLevel2Item(item2, index2, index) {
      let isExpand = !item2.isExpand
      // console.log(item2,isExpand,index,index2)
      item2 = Object.assign(item2, { isExpand })
      this.$set(this.localTreeData[index].childen_data, index2, item2)
      // console.log('---点击了--',  index2,item2)
      //点击二级的时候 肯定是父级已经点开
      let level2_list = JSON.parse(sessionStorage.getItem('expandList'))
      let parent_id = level2_list.findIndex(v=>v.id == item2.parent_driver)
      if (parent_id >-1){
        if (isExpand){
          level2_list[parent_id].child.push({id:item2.id})
      }else {
         let leve_two = level2_list[parent_id].child.findIndex(b=>b.id == item2.id)
          // console.log(level2_list[parent_id].child,item2.id)
          // console.log(leve_two,item2.id)
          if  (leve_two>-1){
            level2_list[parent_id].child.splice(leve_two,1)
          }
        }
        sessionStorage.setItem('expandList',JSON.stringify(level2_list))
      }
    },
    onclickLevel2ItemBorder(item,item2,index){
      if (this.currentDriverId == item2.id && this.current_store_id == item.id) {
        this.currentDriverItemFoucs = !this.currentDriverItemFoucs
      } else {
        this.currentDriverItemFoucs = true
      }
      this.currentDriverId = item2.id
      this.current_store_id = item.id
    } ,
    //初始化数据 设置树是否全部展开或者关闭
    initTreeDataExpand() {

    },
    //对任务类型进行修改 img
    changetaskImg(data,e) {
      let type = ''
      let status = 0
      type = data.is_pickup
      status = data.status
      if (!status){
        status = e?1:0
      }
      if (type == 1) {
        switch (status) {
          case 0:
            return icon_unassignO;
          case 1:
            return icon_purpleO;
          case 2:
            return icon_buleO;
          case 3:
            return icon_greenO;
          case 4:
            return icon_redO;
          default: icon_purpleO
        }
      } else if (type == 0) {
        switch (status) {
          case 0:
            return icon_unassignP;
          case 1:
            return icon_purpleP;
          case 3:
            return icon_greenP;
          case 4:
            return icon_redP;
          case 2:
            return icon_buleP;
        }
      } else {
        return icon_unassignO
      }
    },
    handleKeyDown(event) {
      if ((event.ctrlKey)||(event.metaKey)) {
        this.ctrlKeyActive = true;
      }
    },
    handleKeyUp(event) {
      if ((event.ctrlKey)||(event.metaKey)) {
        this.ctrlKeyActive = false;
      }
    },
  },
  updated() {
    //判断 session 中是否存在当前树的状态，并且将树的状态还原
    this.reloadTreeStatus()
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },
  watch: {
    newTask: {
      handler(val){
        var arr = Object.values(val)
        this.newdropTask = [ ...arr ]
      },
      deep: true
    },
    dropLeaveTreeTask(val) {
      this.delDropTreeTask()
    },
    localTreeData(val){
      // console.log('valvalval',val)
    }

  }
}
</script>
<style lang="less" scoped>
.dragging-layer {
  position: absolute;
  pointer-events: none; /* 防止拖动层捕获鼠标事件 */
  opacity: 0.8;
  width: 282px;
  height: 2px;
  background-color: red;
}
.drag-item {
  user-select: none;
}
.level1-item-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  // border: 1px solid;
  // background-color: aquamarine;
  // margin-bottom: 16px;
  // margin: 8px 0;
  height: 44px;
}

.left-arr-box {
  img {
    width: 14px;
    height: 14px;
  }
}

.set-box {
  img {
    width: 16px;
    margin: 0 8px;
  }
}

.content-box {
  color: white;
  text-align: left;
  font-family: Poppins-Regular, Poppins;
}

.title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.subtitle {
  font-size: 12px;
  color: #CCCCCC;
  font-weight: normal;
  line-height: 20px;
}



.level2-item-box {
  margin: 2px 0px 2px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  //margin: 2px 0;
}

.level3-item-box {
  margin: 2px 0px 2px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 44px;
  border: 1px solid #1F2D42;
}

.item-row {
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
}



.task-index {
  // display: inline-block;
  margin-right: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #CCCCCC;
}

.task-icon {
  margin-right: 8px;

  img {
    width: 16px;
    height: 16px;
  }
}



.task-icon-urgency {
  width: 12px;
  height: 12px;
  // vertical-align: middle;
  // margin-right: 0
}


.item-focus{
  cursor: pointer;
}


.level3-item-box:hover div {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  color: #1F2D42 !important;
}
.active_task,.active_task div{
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  color: #1F2D42 !important;
}
.div#item_foucs:focus {
  background-color: #f5f7fa;
}

.active-driver,
.active-driver div {
  background: rgba(255, 255, 255, 1);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: #1F2D42 !important;
}

.active-task {
  border: 1px solid #FFFFFF;
  margin-left: 24px;
  margin-top: -2px;
}

.active-task-def {
  margin: 0 25px;
}
.item-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 8px;
}


.nochoose{
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}

</style>

